import {
  compressToEncodedURIComponent,
  decompressFromEncodedURIComponent,
} from 'lz-string';
import { type IntlShape } from 'react-intl';

import { toast } from 'react-toastify';

export const deserializeAdvancedFilter = (f) =>
  JSON.parse(decompressFromEncodedURIComponent(f));

export const serializeAdvancedFilter = (f) => {
  return compressToEncodedURIComponent(JSON.stringify(f));
};

export const safeSerializeAdvancedFilter = (
  object: unknown,
  formatMessage: IntlShape['formatMessage']
) => {
  try {
    return serializeAdvancedFilter(object);
  } catch (e) {
    toast.warn(
      formatMessage({
        id: 'app.src.views.widgets.filters.advanced_specialized_filter.error.not_serializable',
        defaultMessage:
          'There is an error generating the filter that is bookmarked in the url.',
      })
    );
    return undefined;
  }
};

export const safeDeserializeAdvancedFilter = (
  urlParam: unknown,
  formatMessage: IntlShape['formatMessage']
) => {
  try {
    return deserializeAdvancedFilter(urlParam);
  } catch (e) {
    toast.warn(
      formatMessage({
        id: 'app.src.views.widgets.filters.advanced_specialized_filter.error.invalid_filter',
        defaultMessage:
          'Link incomplete so no filters loaded. Copy the full URL to fix.',
      })
    );
    return undefined;
  }
};
